import {Component, Input, OnInit, EventEmitter, Output, OnDestroy, ViewChild, ChangeDetectorRef, HostBinding, Inject} from '@angular/core';
import editIcon from '@iconify/icons-mdi/edit-outline';
import dataIcon from '@iconify/icons-mdi/playlist-edit';
import drawIcon from '@iconify/icons-mdi/vector-polygon';
import cropIcon from '@iconify/icons-mdi/sprout-outline';
import cropAddIcon from '@iconify/icons-mdi/shape-polygon-plus';
import dragIcon from '@iconify/icons-mdi/cursor-move';
import areaIcon from '@iconify/icons-mdi/ruler';
import showCropIcon from '@iconify/icons-mdi/eye-outline';
import hideCropIcon from '@iconify/icons-mdi/eye-off-outline';
import listCropIcon from '@iconify/icons-mdi/view-list-outline';
import cutIcon from '@iconify/icons-mdi/content-cut';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Field, FieldCrop, User} from 'shared';
import {featureGroup, FeatureGroup, Map, Polygon} from 'leaflet';
import {Observable, Subject, Subscription} from 'rxjs';
import {finalize, first} from 'rxjs/operators';
import {area, helpers, intersect, difference, getType} from '@turf/turf';
import {FieldService} from '../../stores/field.service';
import {success, error} from '@pnotify/core';
import {DxFormComponent} from 'devextreme-angular';
import * as geojson from 'geojson';
import * as L from 'leaflet';
import DataSource from 'devextreme/data/data_source';
import {CropService} from '../../stores/crop.service';
import {FieldCropService} from '../../stores/field-crop.service';
import * as jsts from 'jsts';
import ArrayStore from 'devextreme/data/array_store';
import {GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {FieldIndexService} from '../../services/field-index.service';
import {confirm} from 'devextreme/ui/dialog';
import {ThirdpartySystemService} from '../../stores/thirdparty-system.service';
import {FieldCropsGridComponent} from '../../field-crops/field-crops-grid/field-crops-grid.component';
import {FieldCropsPopupComponent} from '../../field-crops/field-crops-popup/field-crops-popup.component';

@Component({
  selector: 'app-field-editor-map-edit-control',
  templateUrl: './field-editor-map-edit-control.component.html',
  styleUrls: ['./field-editor-map-edit-control.component.scss'],
  animations: [
    trigger('editMode', [
      state('false', style({
        transform: 'translateY(-150%)'
      })),
      state('true', style({
        transform: 'translateY(0%)'
      })),
      transition('* => *', animate(250)),
    ])
  ]
})
export class FieldEditorMapEditControlComponent implements OnInit, OnDestroy {
  @ViewChild(DxFormComponent)
  form: DxFormComponent;

  @Input()
  mapReady: Observable<Map>;

  @Input()
  editEvent: Subject<{ layer: Polygon, field: Field }>;

  field?: Field;
  fieldCrops?: FieldCrop[];

  @Output()
  editDone = new EventEmitter<{ field: Field, isDeleted: boolean }>();

  map: Map;

  changes: Partial<Field> = {};

  @HostBinding('@editMode')
  editingEnabled = false;

  private editEventSub: Subscription;
  editLayer: FeatureGroup;

  private editFieldCropSubject = new Subject<{ layer: FeatureGroup, field: Field, fieldCrop: FieldCrop }>();
  editFieldCropSubject$ = this.editFieldCropSubject.asObservable();

  drawingErrors: string[] = [];

  areaIcon = areaIcon;

  deleteButtonOptions: any;
  closeButtonOptions: any;
  drawButtonOptions: any;
  editButtonOptions: any;
  cropButtonOptions: any;

  formSaveBtnOptions: any;
  @HostBinding('class.shakeit')
  shake: boolean;
  formVisible: boolean;
  loadingVisible: boolean;
  lockToolbar: boolean;
  formTrackChanges: boolean;

  stripesPatterns: { white: L.StripePattern; black: L.StripePattern };

  cropDs: DataSource;
  fieldCropsDs: DataSource;
  fieldCropsStripes: L.StripePattern[] = [];
  fieldCropsVisible = false;
  fieldCropsLoaded = false;
  fieldCropListVisible = false;
  fieldCropsBtnVisible = false;
  private fieldCropsLayer: FeatureGroup;
  private createMode: string;

  thirdpartySystemFieldsObject = 'thirdparty_systems';
  thirdpartySystemFields = [];
  canEditThirdPartSystems: boolean;

  @ViewChild(FieldCropsPopupComponent)
  fieldCropsPopup: FieldCropsPopupComponent;

  constructor(
    private fieldService: FieldService,
    private fieldIndexService: FieldIndexService,
    private cropService: CropService,
    private fieldCropService: FieldCropService,
    private thirdpartySystemService: ThirdpartySystemService,
    private ref: ChangeDetectorRef,
    public user: User,
    @Inject(GoldenLayoutContainer) public container: GoldenLayout.Container,
  ) {
    this.canEditThirdPartSystems = user.can('edit thirdparty_systems');

    this.fieldCropsDs = fieldCropService.newDataSource({
      paginate: false,
    });

    this.cropDs = cropService.newGroupedDataSource('crop_category_name', {
      paginate: false,
    });

    this.closeButtonOptions = {
      icon: 'close',
      hint: 'Fermer',
      onClick: () => {
        this.disableEditing();
      }
    };

    this.drawButtonOptions = {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${drawIcon.body}</svg>`,
      text: 'Dessiner',
      hint: 'Changer la forme du parcelle',
      onClick: () => {
        this.startDrawing();
      }
    };

    this.editButtonOptions = {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${editIcon.body}</svg>`,
      text: 'Données',
      hint: 'Modifier les données',
      onClick: () => {
        this.showForm();
      }
    };

    this.deleteButtonOptions = {
      icon: 'trash',
      hint: 'Supprimer la parcelle',
      onClick: async () => {
        const confirmed = await confirm('Êtes-vous sûr de vouloir supprimer cette parcelle ?', 'Confirmation');
        if (confirmed) {
          this.deleteField();
        }
      }
    };

    const cropButtonStore = new ArrayStore({
      data: [
        {action: 'grid', name: 'Tableau', icon: 'add'},
        {action: 'add', name: 'Ajouter', icon: 'add'},
        {action: 'list', name: 'Liste', icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${listCropIcon.body}</svg>`},
        {
          action: 'toggle',
          name: 'Afficher',
          icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${showCropIcon.body}</svg>`
        },
      ],
      key: 'action',
    });

    this.cropButtonOptions = {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${cropIcon.body}</svg>`,
      text: 'Cultures',
      hint: 'Gérer les cultures',
      onClick: () => {
        this.fieldCropsPopup.showFieldCrops(this.field);
      }
    };

    this.formSaveBtnOptions = {
      text: 'Sauvegarder',
      type: 'default',
      stylingMode: 'text',
      onClick: () => {
        this.saveChanges();
      }
    };

    // Bindings
    this.codeValidation = this.codeValidation.bind(this);

    // Create Stripes
    this.stripesPatterns = {
      black: new L.StripePattern({color: '#000000', angle: -45}),
      white: new L.StripePattern({color: '#ffffff', angle: -45}),
    };

    thirdpartySystemService.fields('FIELD').subscribe((thirdpartySystemFields) => {
      this.thirdpartySystemFields = thirdpartySystemFields.reduce((all, current) => {
        all.push(...current.toColumns(this, this.thirdpartySystemFieldsObject));
        return all;
      }, []);
    });
  }

  ngOnInit(): void {
    this.mapReady.pipe(first()).subscribe((map) => {
      this.map = map;

      this.stripesPatterns.black.addTo(map);
      this.stripesPatterns.white.addTo(map);

      this.addDrawControls();

      map.on('pm:create', e => {
        if (this.createMode === 'field') {
          this.createNewField(e.layer as Polygon);
        } else {
          this.createNewFieldCrop(e.layer as Polygon);
        }
      });
    });

    this.editEventSub = this.editEvent.subscribe(({layer, field}) => {
      if (this.hasChanges()) {
        this.shakeToolBar();
        return;
      }
      this.formTrackChanges = false;
      layer.remove();
      this.enableEditing(field);
    });
  }

  hasChanges(): boolean {
    return Object.keys(this.changes).length !== 0;
  }

  addFormChange(e: any) {
    if (!this.formTrackChanges) {
      return;
    }
    if (!e.dataField.startsWith(this.thirdpartySystemFieldsObject)) {
      this.changes[e.dataField] = e.value;
    } else {
      this.changes[this.thirdpartySystemFieldsObject] = this.field[this.thirdpartySystemFieldsObject];
    }
  }

  formOnHiding() {
    this.formTrackChanges = false;
  }

  private showForm() {
    if (this.formVisible) {
      return;
    }
    this.formTrackChanges = true;
    this.formVisible = true;
  }

  domainChange(id: number) {
    if (!this.formTrackChanges) {
      return;
    }
    this.changes.domain_id = id;
    this.field.domain_id = id;
  }

  private enableEditing(field: Field) {
    this.cleanupEditing();

    if (!field.id) {
      this.changes.polygon = field.polygon;
    }

    this.field = field;

    this.addPolygon();
    this.editingEnabled = true;
  }

  private disableEditing() {
    if (this.hasChanges()) {
      this.shakeToolBar();
      return;
    }
    this.cleanupEditing();
  }

  private cleanupEditing(isDeleted = false) {
    if (this.field) {
      this.editLayer.remove();
      this.editDone.emit({field: this.field, isDeleted});
      this.field = null;
    }
    this.fieldCropsVisible = false;
    this.fieldCropsLoaded = false;
    this.fieldCropsStripes.forEach(s => s.remove());
    this.formVisible = false;
    this.drawControl(false);
    this.drawingErrors = [];
    // @ts-ignore
    this.map.pm.disableGlobalEditMode();
    this.editingEnabled = false;
    this.changes = {};
  }

  private shakeToolBar() {
    this.shake = true;
    setTimeout(() => {
      this.shake = false;
    }, 820);
  }

  private addPolygon() {
    const layer = this.field.layer;

    this.editLayer = featureGroup();
    this.editLayer.addTo(this.map);

    this.editLayer.addLayer(layer);

    this.addPolygonEditEvents(layer);
  }

  private addPolygonEditEvents(layer: Polygon<any>) {

    layer.on('pm:edit', e => {
      this.field.layer = e.layer;
      this.field.polygon_area = area(this.field.geojson);
      this.changes.polygon = this.field.polygon;
      this.changes.polygon_area = this.field.polygon_area;
      this.checkDrawingErrors();
    });

    layer.on('pm:vertexremoved', e => {
      this.ref.detectChanges();
    });

    layer.on('pm:snapdrag', e => {
      this.field.polygon_area = area(e.layer.toGeoJSON());
      this.changes.polygon = this.field.polygon;
      this.changes.polygon_area = this.field.polygon_area;
      this.ref.detectChanges();
    });

    layer.on('pm:cut', e => {
      this.field.layer = e.layer;

      layer.off('pm:edit');

      this.field.polygon_area = area(this.field.geojson);

      this.changes.polygon = this.field.polygon;
      this.changes.polygon_area = this.field.polygon_area;


      this.editLayer.remove();
      this.addPolygon();
    });
  }

  private startDrawing() {
    this.drawControl(true);
    // @ts-ignore
    this.field.layer.pm.enable();
    // @ts-ignore
    this.map.pm.enableGlobalEditMode({
      snappable: true,
      allowSelfIntersection: true,
    });
  }

  private addDrawControls() {
    // @ts-ignore
    this.map.pm.addControls({
      position: 'topleft',
      drawCircle: false,
      drawCircleMarker: false,
      drawPolyline: false,
      drawRectangle: false,
      drawPolygon: false,
      editMode: true,
      dragMode: true,
      cutPolygon: true,
      removalMode: false,
      drawMarker: false
    });
    this.drawControl(false);
  }

  private drawControl(show: boolean) {
    // @ts-ignore
    (this.map.pm.Toolbar.editContainer as HTMLDivElement).style.display = show ? 'block' : 'none';
  }

  private async showFieldCrops(force?: boolean) {
    // @ts-ignore
    this.map.pm.disableGlobalEditMode();
    if (!force && this.fieldCropsVisible) {
      return;
    }
    if (!force && this.fieldCropsLoaded) {
      this.addFieldCropsPolygons();
      return;
    }

    this.loadingVisible = true;

    this.fieldCropsDs.filter([['field_id', '=', this.field.id], ['archived_at', '=', null]]);
    this.fieldCrops = await this.fieldCropsDs.load();

    this.fieldCropsLoaded = true;
    this.addFieldCropsPolygons();
    this.fieldCropsVisible = true;

    this.loadingVisible = false;
  }

  private hideFieldCrops() {
    this.fieldCropsLayer.remove();
    this.fieldCropsVisible = false;
  }

  private reloadFieldCrops(): Promise<void> {
    this.hideFieldCrops();
    return this.showFieldCrops(true);
  }

  private addFieldCropsPolygons() {
    this.fieldCropsLayer = featureGroup();

    this.fieldCrops.forEach(fieldCrop => {
      const stripe = new L.StripePattern({color: fieldCrop.color, angle: -45});
      stripe.addTo(this.map);
      const fieldCropPolygon = fieldCrop.createLayer({
        // @ts-ignore
        pmIgnore: true,
        weight: 2,
        opacity: 0.5,
        fillOpacity: 0.4,
        color: fieldCrop.color,
        // @ts-ignore
        fillPattern: stripe,
      });
      this.fieldCropsStripes.push(stripe);
      this.fieldCropsLayer.addLayer(fieldCropPolygon);
    });

    this.fieldCropsVisible = true;
    this.fieldCropsLayer.addTo(this.editLayer);
  }

  drawField() {
    this.createMode = 'field';
    // @ts-ignore
    this.map.pm.enableDraw('Polygon', {
      snappable: true,
    });
  }

  private async drawFieldCrop() {
    this.createMode = 'crop';
    await this.showFieldCrops();
    // @ts-ignore
    this.map.pm.enableDraw('Polygon', {
      snappable: true,
    });
  }

  private createNewFieldCropOld(layer: Polygon) {
    this.loadingVisible = true;
    const g = layer.toGeoJSON() as geojson.Feature<geojson.Polygon, any>;
    let cropPolygon = helpers.polygon(g.geometry.coordinates) as any;
    const fieldPolygon = helpers.polygon(this.field.geojson.coordinates);


    for (const fc of this.fieldCrops) {
      const fieldCropPolygon = helpers.polygon(fc.geojson.coordinates);
      cropPolygon = difference(cropPolygon, fieldCropPolygon);
      if (!cropPolygon) {
        break;
      }
    }
    if (!cropPolygon || getType(cropPolygon) !== 'Polygon') {
      error({
        text: 'La culture doit etre à l\'intérieur du parcelle',
        mode: 'light',
      });
      layer.remove();
      this.loadingVisible = false;
      return;
    }

    cropPolygon = intersect(fieldPolygon, cropPolygon);

    if (!cropPolygon || getType(cropPolygon) !== 'Polygon') {
      error({
        text: 'La culture doit etre à l\'intérieur du parcelle',
        mode: 'light',
      });
      layer.remove();
      this.loadingVisible = false;
      return;
    }
    layer.remove();

    const newLayer = L.polygon(L.GeoJSON.coordsToLatLngs(cropPolygon.geometry.coordinates, 1));
    const fieldCrop = FieldCrop.newFromLayer(this.field.id, newLayer);

    this.lockToolbar = true;
    this.loadingVisible = false;
    this.editFieldCropSubject.next({layer: this.editLayer, field: this.field, fieldCrop});
  }

  private createNewFieldCrop(layer: Polygon) {
    const wktReader = new jsts.io.WKTReader();
    const reader = new jsts.io.GeoJSONReader();
    const writer = new jsts.io.GeoJSONWriter();

    this.loadingVisible = true;

    let cropPolygon = reader.read(layer.toGeoJSON().geometry);
    const fieldPolygon = wktReader.read(this.field.polygon);

    for (const fc of this.fieldCrops) {
      const fieldCropPolygon = reader.read(fc.geojson);
      cropPolygon = cropPolygon.difference(fieldCropPolygon);
      if (!cropPolygon || cropPolygon.getGeometryType() !== 'Polygon' || cropPolygon.isEmpty()) {
        break;
      }
    }
    if (!cropPolygon || cropPolygon.getGeometryType() !== 'Polygon' || cropPolygon.isEmpty()) {
      error({
        text: 'La culture doit etre à l\'intérieur du parcelle',
        mode: 'light',
      });
      layer.remove();
      this.loadingVisible = false;
      return;
    }

    cropPolygon = cropPolygon.intersection(fieldPolygon);

    if (!cropPolygon || cropPolygon.getGeometryType() !== 'Polygon' || cropPolygon.isEmpty()) {
      error({
        text: 'La culture doit etre à l\'intérieur du parcelle',
        mode: 'light',
      });
      layer.remove();
      this.loadingVisible = false;
      return;
    }
    layer.remove();
    const final = writer.write(cropPolygon) as geojson.Polygon;
    const newLayer = L.polygon(L.GeoJSON.coordsToLatLngs(final.coordinates, 1));
   

    const fieldCrop = FieldCrop.newFromLayer(this.field.id, newLayer);

    this.lockToolbar = true;
    this.loadingVisible = false;
    this.editFieldCropSubject.next({layer: this.editLayer, field: this.field, fieldCrop});
  }

  private createNewField(layer: Polygon) {
    const field = Field.newFromLayer(layer);
    this.editEvent.next({layer, field});
  }
  
  async fieldCropEditDone() {
    this.addPolygon();
    await this.reloadFieldCrops();
    this.lockToolbar = false;
  }

  async saveChanges() {
    if (this.hasDrawingErrors()) {
      this.shakeToolBar();
      return;
    }
    this.loadingVisible = true;
    let validate = this.form.instance.validate();
    if (validate.status === 'pending') {
      validate = await validate.complete;
    }
    if (!validate.isValid) {
      this.loadingVisible = false;
      this.showForm();
      return;
    }
    const fin = finalize(() => {
      this.loadingVisible = false;
      this.formVisible = false;
      this.changes = {};
      this.drawControl(false);
      // @ts-ignore
      this.map.pm.disableGlobalEditMode();
    });
    if (this.field.id) {
      this.fieldService.update(this.field.id, this.changes as Field).pipe(fin).subscribe(() => {
        success({
          text: 'Modifications enregistrées avec succès',
          mode: 'light',
        });
        this.fieldCropsBtnVisible = true;
      });

    } else {
      const data = Object.assign({}, this.field);
      // @ts-ignore
      delete data._layer;
      // @ts-ignore
      delete data._geojson;
      this.fieldService.insert(data).pipe(fin).subscribe(id => {
        success({
          text: 'Modifications enregistrées avec succès',
          mode: 'light',
        });
        this.field.id = id as number;
        this.fieldCropsBtnVisible = true;
      });
    }
  }

  codeValidation(params: any) {
    return this.fieldService.checkCode(params.value, this.field?.id).toPromise();
  }

  ngOnDestroy(): void {
    this.editEventSub.unsubscribe();
  }

  private deleteField() {
    if (this.field.id) {
      this.fieldService.remove(this.field.id).subscribe(() => {
        success({
          text: 'Modifications enregistrées avec succès',
          mode: 'light',
        });
        this.cleanupEditing(true);
      });
    } else {
      this.cleanupEditing(true);
    }
  }

  private checkDrawingErrors() {
    const field = this.fieldIndexService.checkOverlaps(this.field, 250) as Field;
    if (!field) {
      this.drawingErrors = [];
      this.field.layer.setStyle({
        fillColor: '#3388ff',
        color: '#3388ff',
      });
    } else {
      const msg = `Les deux parcelles sont superposées: ${this.field.name} (${this.field.code}) et ${field.name} (${field.code})`;
      this.drawingErrors.push(msg);
      this.field.layer.setStyle({
        fillColor: '#ff0000',
        color: '#ff0000',
      });
      error({
        text: msg,
        mode: 'light',
      });
    }
  }

  hasDrawingErrors(): boolean {
    return this.drawingErrors.length !== 0;
  }

  checkCode(params: any, system: string, field: string) {
    return this.thirdpartySystemService.checkUnique('FIELD', {
      system,
      field,
      value: params.value,
      id: this.field?.id,
    }).toPromise();
  }
}
